import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConfirmationService, ConfirmationDialog } from '../../services/confirmation.service';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {
    public dialog: ConfirmationDialog | null = null;
    public sanitizedMessage: SafeHtml | null = null;
    private destroy$ = new Subject<void>();

    constructor(
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        this.confirmationService.dialog$
            .pipe(takeUntil(this.destroy$))
            .subscribe(dialog => {
                this.dialog = dialog;
                // Sanitize the message HTML content
                if (dialog?.message) {
                    this.sanitizedMessage = this.sanitizer.bypassSecurityTrustHtml(dialog.message);
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public onConfirm(): void {
        if (this.dialog?.confirmCallback) {
            this.dialog.confirmCallback();
        }
        this.confirmationService.hide();
    }

    public onCancel(): void {
        if (this.dialog?.cancelCallback) {
            this.dialog.cancelCallback();
        }
        this.confirmationService.hide();
    }

    public getConfirmButtonClass(): string {
        const buttonType = this.dialog?.confirmButtonType || 'save';
        
        if (buttonType === 'delete') {
            return 'delete-confirm-btn';
        } else if (buttonType === 'execute') {
            return 'execute-confirm-btn';
        }
        
        return 'save-confirm-btn';
    }
}
